import React from "react";

function PubShimmer() {
    return (
        <div className="container mx-auto px-4 py-8 lg:px-[5%]">
            <div className="flex flex-col lg:flex-row gap-8">
                {/* Left Section - Image Shimmer */}
                <div className="w-full lg:w-1/3 flex justify-center items-center">
                    <div className="w-full h-[500px] bg-gray-200 animate-pulse rounded-lg"></div>
                </div>

                {/* Right Section - Text Shimmer */}
                <div className="w-full lg:w-2/3 p-4">
                    {/* Title Shimmer */}
                    <div className="h-8 w-32 bg-gray-200 animate-pulse mb-8 rounded"></div>

                    {/* First Paragraph Shimmer */}
                    <div className="space-y-4 mb-6">
                        {[1, 2, 3].map((line) => (
                            <div
                                key={line}
                                className="h-4 bg-gray-200 animate-pulse rounded w-full"
                            />
                        ))}
                        <div className="h-4 bg-gray-200 animate-pulse rounded w-3/4"/>
                    </div>

                    {/* Italic Paragraph Shimmer */}
                    <div className="space-y-4">
                        {[1, 2, 3, 4].map((line) => (
                            <div
                                key={line}
                                className="h-4 bg-gray-200 animate-pulse rounded w-full"
                            />
                        ))}
                        <div className="h-4 bg-gray-200 animate-pulse rounded w-3/4"/>
                    </div>
                </div>
            </div>

            {/* Carousel Shimmer */}
            <div className="mt-8">
                <div className="h-10 w-48 bg-gray-200 animate-pulse rounded mb-4"></div>
                <div className="grid grid-cols-3 gap-4">
                    {[1, 2, 3].map((item) => (
                        <div
                            key={item}
                            className="h-48 bg-gray-200 animate-pulse rounded-lg"
                        />
                    ))}
                </div>
            </div>
        </div>
    );
}

export default PubShimmer;